import apiClient from '@u/apiClient'
import Promise from 'lodash-es/_Promise'
import GetAttachmentsFromDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Attachment/GetAttachmentsFromDossierController'
import DeletePictureDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/DeletePictureDossierController'
import AddPictureToDossierPictureController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Picture/AddPictureToDossierPictureController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  getDossierAttachment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAttachmentsFromDossierController.get({
            dossier: payload.dossier_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  deleteDossierPicture: ({ commit }, payload) => {
    return apiClient
      .route(
        DeletePictureDossierController.delete({
          dossier: payload.dossier_id,
          collection_name: payload.collection_name
        })
      )
      .catch(async (reason) => {
        await console.error(reason)
      })
  },
  updateDossierPictureByCollectionName: ({ commit }, payload) => {
    return apiClient
      .route(
        AddPictureToDossierPictureController.post({
          dossier: payload.dossier_id,
          collection_name: payload.collection_name
        }),
        payload.form_data
      )
      .catch(async (reason) => {
        await console.error(reason)
      })
  }
}
